<template>
  <HeroSlider
    :height-first="parseExternalProps(props.heightFirst)"
    :slides="parseExternalProps(props.slides)"
  />
</template>

<script setup>
import HeroSlider from '../../components/HeroSlider/HeroSlider.vue';
import { parseExternalProps } from '../../utils/parseExternalProps';

const props = defineProps({
  slides: {
    type: String,
    default: undefined,
  },
  heightFirst: {
    type: String,
    default: undefined,
  },
});
</script>
